module.exports = __webpack_public_path__ + "static/media/22770611_1629548973786954_5274603260234402741_o.aeb97b53.jpg";